// src/App.jsx
import CashBook from './components/Cashbook/View';
import CashIn from './components/Cashbook/CashIn';
import CashOut from './components/Cashbook/CashOut';
import  RevenueCategories  from './components/settings/RevenueCategories';
import  ExpenseCategories  from './components/settings/ExpenseCategories';
import  Services  from './components/settings/Services';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/Auth/PrivateRoute';
import Dashboard from './components/Dashboard/Dashboard';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import RegisterClient from './components/clients/Register';
import ListClient from './components/clients/List';
import {ViewClient} from './components/clients/view';
import ClientEdit from './components/clients/Edit';
import Invoices from './components/Invoices/Create';


function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/cashbook"
            element={
              <PrivateRoute>
                <CashBook />
              </PrivateRoute>
            }
          />

          <Route
            path="/cashin"
            element={
              <PrivateRoute>
                <CashIn />
              </PrivateRoute>
            }
          />
          <Route
            path="/cashout"
            element={
              <PrivateRoute>
                <CashOut />
              </PrivateRoute>
            }
          />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
        <Route
          path="/clients/list"
          element={
            <PrivateRoute>
              <ListClient />
            </PrivateRoute>
          }
        />
        <Route
          path="/clients/register"
          element={
            <PrivateRoute>
              <RegisterClient />
            </PrivateRoute>
          }
        />

        <Route path="/clients/view/:id" element={
            <PrivateRoute>
              <ViewClient />
            </PrivateRoute>
          }
        />
        <Route path="/clients/edit/:id" element={
            <PrivateRoute>
              <ClientEdit />
            </PrivateRoute>
          }
        />
        <Route path="/expense-categories" element={
            <PrivateRoute>
              <ExpenseCategories />
            </PrivateRoute>
          }
        />
        <Route path="/revenue-categories" element={
            <PrivateRoute>
              <RevenueCategories />
            </PrivateRoute>
          }
        />
        <Route path="/services" element={
            <PrivateRoute>
              <Services />
            </PrivateRoute>
          }
        />
        <Route path="/invoices" element={
            <PrivateRoute>
              <Invoices />
            </PrivateRoute>
          }
        />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;